<template>

    <div class="row">
        <div class="col-12">
            <div class="col-12">
                <h1 class="title-tab-content">ویرایش اطلاعات شخصی</h1>
            </div>
            <div class="content-section default">
                <div class="row">
                    <div class="col-12">
                        <h1 class="title-tab-content">حساب شخصی</h1>
                    </div>
                </div>
                <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                    <li v-for="error in errors.all()">{{ error }}</li>
                </ul>
                <form class="form-account" @submit.prevent="validateForm">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <div class="form-account-title">نام</div>
                            <div class="form-account-row">
                                <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                                <input class="input-field text-right" type="text" v-model="profileinfo.FirstName" v-validate="{required: true , max:50}" data-vv-as="نام" placeholder="نام خود را وارد نمایید">
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-account-title">نام خانوادگی</div>
                            <div class="form-account-row">
                                <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                                <input class="input-field text-right" type="text" v-model="profileinfo.LastName" v-validate="{required: true , max:200}" data-vv-as="نام خانوادگی" placeholder="نام خانوادگی خود را وارد نمایید">
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-account-title">کد ملی</div>
                            <div class="form-account-row">
                                <label class="input-label"><i class="now-ui-icons objects_key-25"></i></label>
                                <input class="input-field aaaa" type="text" v-model="profileinfo.NationalCode" v-validate="{numeric: true , digits :10}" data-vv-as="کد ملی" placeholder="کد ملی خود را وارد نمایید">
                            </div>
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <div class="form-account-title">شماره موبایل</div>
                            <div class="form-account-row">
                                <label class="input-label"><i class="now-ui-icons tech_mobile"></i></label>
                                <input class="input-field" v-model="profileinfo.UserName" readonly="readonly" type="text" placeholder="شماره موبایل خود را وارد نمایید">
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-account-title">شماره کارت</div>
                            <div class="form-account-row">
                                <label class="input-label"><i class="now-ui-icons shopping_credit-card"></i></label>
                                <input class="input-field" v-model="profileinfo.BankCardNo" v-validate="'digits:16'" data-vv-as="شماره کارت" type="text" placeholder=" شماره کارت خود را وارد نمایید">
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-account-title">آدرس ایمیل</div>
                            <div class="form-account-row">
                                <label class="input-label"> <i class="now-ui-icons ui-1_email-85"></i></label>
                                <input class="input-field" v-model="profileinfo.Email" v-validate="{email:true}" data-vv-as="ایمیل" type="email" placeholder=" آدرس ایمیل خود را وارد نمایید">
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12">
                            <div class="form-account-title">جنسیت</div>
                            <div class="product-variants default">
                                <div class="radio">
                                    <input type="radio" v-model="profileinfo.Gender" name="Gender" id="radio1" value="true" checked="checked">
                                    <label for="radio1">
                                        <span  class="text">مرد</span>
                                    </label>
                                </div>
                                <div></div>
                                <div class="radio">
                                    <input type="radio" v-model="profileinfo.Gender" name="Gender" id="radio2" value="false">
                                    <label for="radio2">
                                        <span  class="text"> زن</span>
                                    </label>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                    <div class="col-12 no-padding">
                        <div class="form-account-agree">
                            <label class="checkbox-form checkbox-primary">
                                <input type="checkbox" id="agree-Email" v-model="profileinfo.IsEmailNewsLatterSubsciber">
                                <span class="checkbox-check"></span>
                            </label>
                            <label for="agree-Email" v-if="baseInfo != null">
                                اشتراک در خبرنامه {{baseInfo.ShopName}} از طریق ایمیل
                            </label>
                        </div>
                    </div>
                    <div class="col-12 no-padding">
                        <div class="form-account-agree">
                            <label class="checkbox-form checkbox-primary">
                                <input type="checkbox" id="agree-SmS" v-model="profileinfo.IsSMSNewsLatterSubsciber">
                                <span class="checkbox-check"></span>
                            </label>
                            <label for="agree-SmS" v-if="baseInfo != null">
                                اشتراک در خبرنامه {{baseInfo.ShopName}} از طریق اس ام اس
                            </label>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <button type="submit" class="btn btn-default btn-lg">ذخیره</button>
                        <router-link to="/" type="button" class="btn btn-default btn-lg">انصراف</router-link>
                    </div>
                </form>
            </div>
        </div>
        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
    </div>
</template>
<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return { profileinfo: {}, isShowSppiner: false }
        },
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        beforeMount: function () {
            createPageTitle('ویرایش اطلاعات');
            this.isShowSppiner = true;
            httpPromise(this, '/v1/Identity/CustomersProfile/ReadProfile', 'get', '',
                response => {
                    this.profileinfo = response.data.Value;
                    this.isShowSppiner = false;
                },
                response => {
                    toastr.error(response.data.Message);
                    this.isShowSppiner = false;
                });

        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true; 
                        httpPromise(this, '/v1/Identity/CustomersProfile/Update', 'post', JSON.stringify(this.profileinfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                this.$store.commit('setUserFullName', this.profileinfo.FirstName + ' ' + this.profileinfo.LastName);
                                this.isShowSppiner = false;
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            }
        },
    }
</script>

<style scoped>
    .product-variants {
        margin: 0px 0 40px;
        padding-right:20px;
    }
</style>